import type { CityConfig } from "../city-template/types";

export const woosterConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Wayne County Probate Court", href: "https://www.wayneohio.org/probate-court", description: "Wayne County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Wayne County Clerk of Courts", href: "https://www.wayneohio.org/clerk-of-courts", description: "Wayne County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Wooster",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "wooster",
  route: "/wooster",
  title: "Emergency Passport Wooster, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Wooster, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Wayne County and the surrounding Amish Country area including Orrville, Rittman, and Millersburg. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Wooster, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Wooster and Wayne County travelers — including the Amish Country region — get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wooster%20Ohio%20downtown%20historic%20district%20with%20charming%20brick%20buildings%20and%20tree-lined%20streets%20in%20the%20heart%20of%20Amish%20Country%2C%20golden%20afternoon%20sunlight%20casting%20warm%20glows%20on%20well-preserved%2019th%20century%20architecture%2C%20local%20shops%20and%20cafes%20visible%20on%20Main%20Street%2C%20American%20small%20town%20atmosphere%20with%20autumn%20foliage%2C%20professional%20photography%20with%20rich%20earthy%20tones%20and%20a%20welcoming%20community%20feel&width=1800&height=700&seq=wooster-hero-oh-001&orientation=landscape",
  heroImageAlt: "Wooster Ohio downtown historic district in the heart of Amish Country",
  geoPosition: "40.8051;-81.9351",
  geoPlacename: "Wooster, Ohio",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 330 miles from Wooster via I-80",
  },
  nearbyCitiesZips: [
    { name: "Wooster", zips: "44691, 44692" },
    { name: "Orrville", zips: "44667" },
    { name: "Rittman", zips: "44270, 44271, 44273, 44274" },
    { name: "Millersburg", zips: "44654" },
    { name: "Dalton", zips: "44618" },
    { name: "Shreve", zips: "44676" },
    { name: "Smithville", zips: "44677" },
    { name: "West Salem", zips: "44287" },
    { name: "Apple Creek", zips: "44606" },
    { name: "Mount Eaton", zips: "44259" },
    { name: "Fredericksburg", zips: "44627" },
    { name: "Kidron", zips: "44636" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Wooster departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-global-line", title: "Amish Country Coverage", desc: "Serving Wayne County and the surrounding rural communities" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Akron, OH", route: "/akron" },
    { name: "Fast passport renewal in Mansfield, OH", route: "/mansfield" },
    { name: "Emergency passport help in Canton, OH", route: "/canton" },
    { name: "Urgent passport services in Columbus, OH", route: "/columbus-oh" },
    { name: "Same-day passport help in Medina, OH", route: "/medina" },
    { name: "Passport courier services in Cleveland, OH", route: "/cleveland" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Wooster remotely via secure courier. We do not have a walk-in office in Wooster — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Wayne County and the surrounding Amish Country region.",
  fpcOfficeDistance: "Serving all of Wayne County and the surrounding Amish Country area",
  fpcOfficeAddress: "175 S Third St, Ste 200, Columbus, Ohio 43215",
  serviceAreaIntro: "From downtown Wooster to the rural communities of Wayne County and the Amish Country region, from Orrville and Rittman to Millersburg and Dalton — Fast Passport Center serves the entire area. We regularly help travelers from the rural communities surrounding Wooster get their passports fast.",
  nearbyCitiesIntro: "We serve all Wooster neighborhoods and the surrounding Wayne County region including Orrville, Rittman, Millersburg, Dalton, Shreve, Smithville, West Salem, Apple Creek, Mount Eaton, Fredericksburg, and Kidron. If you are anywhere in the Wooster area or Amish Country, we have you covered.",
  howItWorksIntro: "Most Wooster travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Wooster travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Wooster and Wayne County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Wooster? Here are the most common ones we hear from Wayne County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Wooster international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Rachel M.",
      location: "Wooster, OH",
      rating: 5,
      text: "My passport expired the week before our mission trip to Guatemala. Fast Passport Center had my renewal ready in 4 days. They were incredibly patient explaining everything to me over the phone.",
      service: "Passport Renewal",
    },
    {
      name: "James T.",
      location: "Orrville, OH",
      rating: 5,
      text: "I thought I'd have to drive to Cleveland or Columbus for an emergency passport. Fast Passport Center handled everything from right here in Wayne County. Got mine in 3 days.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah K.",
      location: "Millersburg, OH",
      rating: 5,
      text: "Living in Amish Country, I worried about access to expedited services. Fast Passport Center made it so easy — everything was done online and shipped overnight. My passport arrived in 5 days.",
      service: "New Passport",
    },
    {
      name: "Michael B.",
      location: "Rittman, OH",
      rating: 5,
      text: "Business trip to Germany came up with only 6 days notice. They got me a passport in 4 business days. Professional, thorough, and kept me updated every day.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "wooster-1",
      name: "Wooster Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "402 N Market St",
      city: "Wooster",
      state: "OH",
      zip: "44691",
      phone: "(330) 264-8925",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Wooster",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Main downtown facility. High volume — appointments strongly recommended. Serves all of Wayne County.",
      icon: "ri-mail-line",
    },
    {
      id: "wooster-2",
      name: "Orrville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "160 N Main St",
      city: "Orrville",
      state: "OH",
      zip: "44667",
      phone: "(330) 682-1161",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Orrville, 10 miles east of Wooster",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Wayne County residents. Less crowded than Wooster. Call for appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "wooster-3",
      name: "Rittman Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 S Main St",
      city: "Rittman",
      state: "OH",
      zip: "44270",
      phone: "(330) 925-1161",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Rittman, 15 miles north of Wooster",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Wayne County and southern Medina County. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "wooster-4",
      name: "Millersburg Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "190 N Clay St",
      city: "Millersburg",
      state: "OH",
      zip: "44654",
      phone: "(330) 674-5016",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Millersburg, 25 miles southeast of Wooster",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Holmes County and the Amish Country region. Rural location with limited hours.",
      icon: "ri-mail-line",
    },
    {
      id: "wooster-5",
      name: "Wayne County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "428 W Liberty St",
      city: "Wooster",
      state: "OH",
      zip: "44691",
      phone: "(330) 287-5590",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Wayne County Courthouse",
      website: "https://www.wayneohio.org/",
      websiteLabel: "Wayne County Government",
      notes: "Accepts passport applications. Good alternative to post office with extended hours and appointment availability.",
      icon: "ri-government-line",
    },
    {
      id: "wooster-6",
      name: "Smithville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 S Milton St",
      city: "Smithville",
      state: "OH",
      zip: "44677",
      phone: "(330) 669-2181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Smithville, 8 miles south of Wooster",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Wayne County communities. Smaller facility — call ahead for availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Wooster photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Wayne County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Wooster applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Wayne County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Wooster travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Wooster." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Wooster address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Wooster before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Wooster for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — without the long drive to Chicago." },
    { q: "How fast can I renew my passport in Wooster?", a: "Fast Passport Center offers fast passport renewal in Wooster in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "I live in the Amish Country area — can you still help me?", a: "Absolutely. Fast Passport Center serves the entire Amish Country region including Millersburg, Berlin, Sugarcreek, and all surrounding Wayne and Holmes County communities. Our courier service works seamlessly from any rural address — no need to travel to a major city." },
    { q: "Can I get a same-day passport appointment near Wooster?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5.5 hours from Wooster — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Wayne County residents." },
    { q: "Can I expedite a child passport in Wooster?", a: "Yes. Fast Passport Center expedites child passports in Wooster for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Wayne County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Wooster with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "What is the closest passport agency to Wooster?", a: "The nearest regional passport agency to Wooster is the Chicago Passport Agency, approximately 330 miles away via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Wooster without any in-person agency visit required." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Wooster", address: "1534 E High St, Wooster, OH 44691", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Wooster", address: "1800 Cleveland Rd, Wooster, OH 44691", hours: "Mon-Sun: 7AM-11PM" },
    { name: "Walmart Supercenter — Wooster", address: "3883 Burbank Rd, Wooster, OH 44691", hours: "Mon-Sun: 6AM-11PM" },
    { name: "CVS Pharmacy — Orrville", address: "165 N Main St, Orrville, OH 44667", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Orrville", address: "200 S Main St, Orrville, OH 44667", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Millersburg", address: "1875 S Washington St, Millersburg, OH 44654", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walmart — Rittman", address: "215 S Main St, Rittman, OH 44270", hours: "Mon-Sun: 6AM-11PM" },
    { name: "CVS Pharmacy — Rittman", address: "100 S Main St, Rittman, OH 44270", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Wayne County BMV — Wooster",
      address: "2579 S Cleveland Rd, Wooster, OH 44691",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Orrville License Bureau",
      address: "160 N Main St, Orrville, OH 44667",
      hours: "Mon-Fri: 8AM-4:30PM",
      note: "Alternative for eastern Wayne County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "Rittman License Bureau",
      address: "100 S Main St, Rittman, OH 44270",
      hours: "Mon-Fri: 8AM-4:30PM",
      note: "Serves northern Wayne County and southern Medina County.",
      featured: false,
    },
    {
      name: "AAA — Wooster",
      address: "3783 Burbank Rd, Wooster, OH 44691",
      hours: "Mon-Fri: 8AM-5:30PM, Sat: 9AM-12PM",
      note: "AAA members can renew licenses and access passport photo services at this location.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CAK",
      name: "Akron-Canton Airport",
      distance: "32 miles southeast of Wooster",
      address: "5400 Lauby Rd NW, North Canton, OH 44720",
      note: "Closest commercial airport to Wooster. Direct flights to major hubs including Chicago, Atlanta, and Charlotte. Popular for Wayne County travelers.",
      flightUrl: "https://www.akroncantonairport.com/",
      flightLabel: "CAK Airport",
      featured: true,
    },
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "55 miles north of Wooster",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Major international hub with extensive domestic and international routes. Best option for long-haul international travel.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "Cleveland Airport",
      featured: false,
    },
    {
      code: "CMH",
      name: "John Glenn Columbus International Airport",
      distance: "85 miles south of Wooster",
      address: "4600 International Gateway, Columbus, OH 43219",
      note: "Larger hub with additional international routes. Alternative for southern Wayne County residents.",
      flightUrl: "https://www.flycmh.com/",
      flightLabel: "Columbus Airport",
      featured: false,
    },
  ],
};